export class QuickPayEnrollment {
    memCode: string;
    secondFactorAuth: string;
    firstName: string;
    lastName: string;
    email: string;
}
